<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
            <v-layout row  wrap>
                <v-flex xs12>

                    <v-layout v-if="config.promoCountdown=='S'" :class="config.campagnaWeb=='S' ? 'text-md-center sellaBold' : ''">
                        <v-img :src="config.promoCountdown=='S' ? config.promoCountdownLink : ''" aspect-ratio=6.10 style="width: 60%; height: 30%; cursor:pointer"></v-img>
                    </v-layout>

                        <v-card-title >
                            <v-layout  align-center justify-space-between row fill-height>
                                <v-flex md6 xs6>
                                    <v-img :src="config.campagnaWeb=='S' ? '../img/logo_prontotuo.png' : '../img/logo_prontotuo.png'" aspect-ratio="1" max-width="100"
                                           max-height="100"></v-img>
                                </v-flex>
                                <v-flex xs10 class="hidden-m-and-down"></v-flex>
                                <v-flex md6 xs10>
                                            <v-img :src="config.campagnaWeb=='S' ? '../img/SPC_logo.png' : '../img/SPC_logo.png'"  aspect-ratio="2.68" max-width="210"
                                                   max-height="220"></v-img>
                                </v-flex>
                            </v-layout>
                        </v-card-title>
                        <v-layout row wrap>

                            <v-flex xs12 md6>

                                <v-card-title primary-title>
                                    <div>
                                    <span :class="config.campagnaWeb=='S' ? '' : ''">
                                        Richiedi un prestito ProntoTuo da casa in modo pratico e veloce. Su ProntoTuo.it sei sempre assistito, fai tutto in diretta con un vero professionista e puoi ottenere fino a 60.000 euro.<br>
                                    </span>
                                    </div>
                                </v-card-title>
                                <div :class="$vuetify.breakpoint.smAndDown ? '' : '' ">
                                    <strong :class="config.campagnaWeb=='S' ? 'primary--text display-2 font-weight-bold sellaStencil' : 'primary--text display-2 font-weight-bold sellaStencil'">Comodità digitale, consulenza reale!</strong>
                                </div>

                            </v-flex>

                            <v-dialog v-model="videoPT" width="675">
                                <template v-slot:activator="{ on }">
                                        <v-flex xs12 md6 >
                                            <v-img v-on="on" :src="config.campagnaWeb=='S' ? config.pathImgPromo : config.pathImgDefault" style="cursor:pointer" aspect-ratio=1.20></v-img>
                                        </v-flex>
                                </template>
                                <v-card>
                                    <v-card-title class="headline grey lighten-2" primary-title>
                                        <v-icon left>movie</v-icon>ProntoTuo
                                    </v-card-title>
                                    <v-card-text>
                                        <div class="container">
                                            <div class="row multi-columns-row post-columns" >
                                                <video width="100%" height="100%" controls="true">
                                                    <source :src="config.campagnaWeb=='S' ? config.pathVidPromo : config.pathVidDefault" type="video/mp4">
                                                </video>
                                            </div>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn round color="secondary" flat @click="videoPT = false"> Chiudi </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                        </v-layout>
                        <v-card-actions>
                            <v-layout justify-center row wrap pt-4>
                                <v-btn round :color="config.campagnaWeb=='S' ? 'primary' : 'primary'" :class="config.campagnaWeb=='S' ? 'info--text' : 'info--text'" @click="scrollToEl('prodotto')">Scopri pronto tuo</v-btn>
                                <v-btn round :color="config.campagnaWeb=='S' ? 'primary' : 'primary'" :class="config.campagnaWeb=='S' ? 'info--text' : 'info--text'" @click="scrollToEl('rata')">Calcola rata</v-btn>
                            </v-layout>
                        </v-card-actions>

                </v-flex>
            </v-layout>
</template>

<script>
    export default {
        data (){
            return {
                drawer:false,
                videoPT: false
            }
        },
        props:{
            config: {}
        },
        methods:{
            scrollToEl(name){
                this.$emit('scrollTo',name );
                this.drawer=false;
            }
        }
    }
</script>


<style scoped>

    @font-face {
        font-family: 'Sella';
        src: url('../assets/fonts/Sella-Regular.woff2') format('woff2'),
        url('../assets/fonts/Sella-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella Stencil';
        src: url('../assets/fonts/SellaStencil-Regular.woff2') format('woff2'),
        url('../assets/fonts/SellaStencil-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella';
        src: url('../assets/fonts/Sella-Bold.woff2') format('woff2'),
        url('../assets/fonts/Sella-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella Stencil';
        src: url('../assets/fonts/SellaStencil-Bold.woff2') format('woff2'),
        url('../assets/fonts/SellaStencil-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella Stencil';
        src: url('../assets/fonts/SellaStencil-Medium.woff2') format('woff2'),
        url('../assets/fonts/SellaStencil-Medium.woff') format('woff');
        font-weight: 500;
        font-style: normal;
    }

    @font-face {
        font-family: 'Sella';
        src: url('../assets/fonts/Sella-Medium.woff2') format('woff2'),
        url('../assets/fonts/Sella-Medium.woff') format('woff');
        font-weight: 500;
        font-style: normal;
    }

    .sellaRegular {
        font-family: 'Sella' !important;
    }

    .sellaStencil {
        font-family: 'Sella Stencil' !important;
    }
</style>
